import { render, staticRenderFns } from "./Step3ForPurchaser.vue?vue&type=template&id=116c131e&lang=pug"
import script from "./Step3ForPurchaser.vue?vue&type=script&lang=js"
export * from "./Step3ForPurchaser.vue?vue&type=script&lang=js"
import style0 from "./Step3ForPurchaser.vue?vue&type=style&index=0&id=116c131e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports